import React from 'react';
import PropTypes from 'prop-types';
import Container from './Container.jsx';
import {
  loadBranches,
  loadEmployeeById,
  loadEmployees,
  loginDefaultState,
  loginEmployee,
  onLoginFlowChange,
  saveEmployeeProfile,
  searchEmployeeConflicts,
  selectEmployee,
} from '../../state';
import useNeuroState, {useDispatch} from '../../../state';
import { Modal } from '../../../../neuro-ui';

const EmployeeLoginFlow = ({ ...rest }) => {
  const dispatch = useDispatch();
  const { employeeLoginState = loginDefaultState } = useNeuroState();
  const { loginComplete } = employeeLoginState;

  //TODO: get rid of this by refactoring child components to dispatch on their own
  const employeeLoginRefactoredReduxFunctions = {
    loadEmployees: (searchValue) => {
      dispatch(loadEmployees(searchValue));
    },
    loadEmployeeById: (searchObj) => {
      dispatch(loadEmployeeById(searchObj));
    },
    searchEmployeeConflicts: (searchObj) => {
      dispatch(searchEmployeeConflicts(searchObj));
    },
    loadBranches: (searchValue) => {
      dispatch(loadBranches(searchValue));
    },
    saveEmployeeProfile: (employee) => {
      dispatch(saveEmployeeProfile(employee));
    },
    onEmployeeSelected: (employee) => {
      dispatch(selectEmployee(employee));
    },
    loginEmployee: (profile) => {
      dispatch(loginEmployee(profile));
    },
    loginFlowChanged: (
      stepToAdd = '',
      stepToRemove = '',
      shouldReset = false
    ) => {
      dispatch(onLoginFlowChange({ stepToAdd, stepToRemove, shouldReset }));
    },
  };

  return <Modal
    show={!loginComplete}
    onClose={() => {}}
    className="employee-login"
    nodeId="root"
    closeBtn={<span />}
  >
    {!loginComplete ? (
      <Container
        {...rest}
        {...employeeLoginState}
        {...employeeLoginRefactoredReduxFunctions}
      />
    ) : null}
  </Modal>;
};

EmployeeLoginFlow.propTypes = {
  locale: PropTypes.string,
};

export default EmployeeLoginFlow;
